// extracted by mini-css-extract-plugin
module.exports = {"Referral":"Referral_Referral__6O3Uq"};